import { Stack, styled, Typography } from '@mui/material';
import { Section } from '@rumblefish/ui/Rumblefish23Theme';

export const StyledSection = styled(Section)(() => ({
  paddingBottom: '4rem',
}));

export const StyledStack = styled(Stack)(({ theme }) => ({
  flexFlow: 'row nowrap',
  alignItems: 'center',
  padding: theme.spacing(0, 4, 12, 8),
  [theme.breakpoints.down('md')]: {
    flexFlow: 'column wrap',
    gap: theme.spacing(4),
    padding: theme.spacing(0),
  },
  [theme.breakpoints.down('sm')]: {
    flexFlow: 'column wrap',
    padding: theme.spacing(4, 0, 0, 0),
  },
}));

export const StyledImageContainer = styled(Stack)(({ theme }) => ({
  zIndex: '1',
  width: '60%',
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

export const StyledImage = styled('img')(() => ({
  zIndex: 1,
  objectFit: 'cover',
  width: '100%',
  height: 'auto',
  objectPosition: 'right',
  aspectRatio: '8/5',
}));

export const StyledText = styled(Typography)(({ theme }) => ({
  width: '44%',
  marginLeft: '-4%',
  color: 'white',
  background: '',
  zIndex: 2,
  [theme.breakpoints.down('md')]: {
    width: '100%',
    marginLeft: '0',
  },
}));
